var _circle, _circle2, _circle3, _circle4, _circle5, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 1900,
    style: {
      fill: "none"
    },
    viewBox: "0 0 1900 1900",
    width: 1900,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 950,
    fill: "#7D2AE7",
    r: 950
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 950,
    fill: "url(#paint0_radial)",
    r: 950
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 950,
    fill: "url(#paint1_radial)",
    r: 950
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 950,
    fill: "url(#paint2_radial)",
    r: 950
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 950,
    fill: "url(#paint3_radial)",
    r: 950
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1707.73 1002.08C1705.18 1002.08 1702.91 1003.79 1701.78 1007.19C1686.37 1051.05 1665.57 1077.23 1648.46 1077.23C1638.63 1077.23 1634.66 1066.27 1634.66 1049.06C1634.66 1006.15 1660.47 915.025 1673.32 873.433C1674.84 869.145 1675.7 864.651 1675.88 860.104C1675.88 848.005 1669.26 842.05 1652.91 842.05C1636.55 842.05 1616.23 849.045 1597.89 881.373C1591.46 852.826 1572.18 840.348 1545.24 840.348C1514.14 840.348 1484.08 860.388 1459.31 892.811C1434.55 925.234 1405.53 936.01 1383.6 930.716C1399.38 892.244 1405.15 863.413 1405.15 842.05C1405.15 808.492 1388.61 788.264 1361.86 788.264C1321.11 788.264 1297.67 827.114 1297.67 867.95C1297.67 899.522 1311.95 932.04 1343.52 947.826C1317.14 1007.47 1278.58 1061.45 1263.93 1061.45C1245.02 1061.45 1239.44 969 1240.58 902.831C1241.14 864.925 1244.36 862.94 1244.36 851.408C1244.36 844.886 1240.01 840.348 1222.9 840.348C1182.92 840.348 1170.44 874.284 1168.64 913.229C1167.95 927.995 1165.64 942.641 1161.74 956.9C1144.92 1016.64 1110.51 1061.92 1088.01 1061.92C1077.52 1061.92 1074.78 1051.43 1074.78 1037.82C1074.78 994.901 1098.79 941.114 1098.79 895.363C1098.79 861.617 1084.04 840.348 1056.15 840.348C1023.45 840.348 980.06 879.388 939.035 952.363C952.553 896.497 958.035 842.333 918.145 842.333C909.464 842.467 900.941 844.671 893.284 848.761C887.801 851.597 884.871 856.701 885.249 862.373C889.03 922.02 837.229 1074.49 788.075 1074.49C779.095 1074.49 774.841 1064.85 774.841 1049.16C774.841 1006.24 800.458 915.308 813.314 873.622C814.88 869.085 815.741 864.335 815.866 859.537C815.866 848.194 808.871 842.333 792.896 842.333C775.314 842.333 756.314 849.045 737.881 881.373C731.453 852.826 712.169 840.348 685.324 840.348C641.179 840.348 591.741 887.045 570.095 948.015C541.075 1029.31 482.562 1107.77 403.821 1107.77C332.358 1107.77 294.642 1048.31 294.642 954.443C294.642 818.701 394.274 707.915 468.1 707.915C503.453 707.915 520.279 730.413 520.279 764.915C520.279 806.697 497.025 826.075 497.025 841.955C497.025 846.776 500.995 851.597 509.03 851.597C541.169 851.597 578.886 813.881 578.886 762.458C578.886 711.035 537.199 673.318 463.279 673.318C341.244 673.318 218.358 796.204 218.358 953.592C218.358 1078.84 280.179 1154.37 386.995 1154.37C459.876 1154.37 523.587 1097.75 557.995 1031.48C561.871 1086.4 586.732 1114.95 624.637 1114.95C658.383 1114.95 685.702 1094.91 706.592 1059.56C714.627 1096.52 735.896 1114.67 763.592 1114.67C795.353 1114.67 821.821 1094.53 847.06 1057.19C846.682 1086.5 853.393 1114.1 878.821 1114.1C890.826 1114.1 905.194 1111.36 907.746 1100.87C934.403 990.174 1000.67 899.806 1020.9 899.806C1026.85 899.806 1028.46 905.478 1028.46 912.378C1028.46 942.438 1007.28 1004.07 1007.28 1043.39C1007.28 1086.02 1025.34 1114.1 1062.68 1114.1C1104.08 1114.1 1146.14 1063.43 1174.22 989.323C1183.01 1058.52 1202.01 1114.38 1231.6 1114.38C1268.08 1114.38 1332.84 1037.72 1372.06 956.428C1387.38 958.413 1410.54 957.94 1432.66 942.249C1423.3 966.164 1417.72 992.348 1417.72 1018.44C1417.72 1093.87 1453.64 1114.95 1484.65 1114.95C1518.39 1114.95 1545.71 1094.91 1566.6 1059.56C1573.5 1091.41 1591.08 1114.57 1623.51 1114.57C1674.17 1114.57 1718.22 1062.77 1718.22 1020.23C1718.22 1008.99 1713.4 1002.08 1707.73 1002.08ZM655.642 1073.26C635.13 1073.26 627.095 1052.56 627.095 1021.84C627.095 968.527 663.582 879.294 702.244 879.294C719.07 879.294 725.498 899.239 725.498 923.532C725.498 977.697 690.806 1073.26 655.642 1073.26V1073.26ZM1356.85 913.891C1344.65 899.333 1340.21 879.483 1340.21 861.9C1340.21 840.159 1348.15 821.821 1357.7 821.821C1367.24 821.821 1370.08 831.179 1370.08 844.224C1370.08 865.965 1362.33 897.915 1356.85 913.891V913.891ZM1515.56 1073.26C1495.14 1073.26 1487.1 1049.54 1487.1 1021.84C1487.1 970.323 1523.59 879.294 1562.54 879.294C1579.36 879.294 1585.41 898.955 1585.41 923.532C1585.41 977.697 1551.29 1073.26 1515.56 1073.26V1073.26Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    gradientTransform: "rotate(-49.416 2013.483 443.185) scale(1469.49)",
    gradientUnits: "userSpaceOnUse",
    id: "paint0_radial",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    gradientTransform: "rotate(54.703 42.717 594.194) scale(1657.12)",
    gradientUnits: "userSpaceOnUse",
    id: "paint1_radial",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(1023.00018 -1030.00171 473.71139 470.4913 367 1684)",
    gradientUnits: "userSpaceOnUse",
    id: "paint2_radial",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    gradientTransform: "rotate(66.52 193.341 720.338) scale(1495.86 2505.9)",
    gradientUnits: "userSpaceOnUse",
    id: "paint3_radial",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.726
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanva);
export default __webpack_public_path__ + "static/media/Canva.0f0b2ed198b63b099a14bc21cb59d1c9.svg";
export { ForwardRef as ReactComponent };